import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

export const isMixpanelBrowserEnabled = () => Boolean(MIXPANEL_TOKEN);

if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: false,
    track_pageview: false,
    persistence: "localStorage",
  });
}

export const trackMixpanelEvent = (eventName: string, properties: Record<string, any> = {}) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.track(eventName, properties);
};

export const identifyMixpanelUser = (userId: string, properties: Record<string, any> = {}) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.identify(userId);
  mixpanel.people.set({
    $name: properties.name || userId,
    $email: properties.email || "",
    ...properties,
  });
};

export const trackAppSessionDuration = () => {
  if (!MIXPANEL_TOKEN) return;

  const startedAt = Number(sessionStorage.getItem("mixpanel_session_started_at") || Date.now());
  sessionStorage.setItem("mixpanel_session_started_at", String(startedAt));

  const flushSession = () => {
    const now = Date.now();
    const durationMs = now - startedAt;
    mixpanel.track("app_session", {
      duration_ms: durationMs,
      session_started_at: new Date(startedAt).toISOString(),
    });
  };

  window.addEventListener("beforeunload", flushSession, { once: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      flushSession();
    }
  });
};
